import React from 'react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

function ReleaseGame() {
  const {
    data: games,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['featured-web-games'],
    queryFn: async () => {
      const { data } = await axios.get(
        `https://be-staging.obigin.com/content/featured-web-games`
      );
      return data.data;
    },
  });

  const liveGames = games?.filter((game) => game.status === 'live');

  if (isLoading) return <p className="text-white text-center">Loading released games...</p>;
  if (isError) return <p className="text-danger text-center">Failed to load games.</p>;

  return (
    <section className="upcoming-games-area pt-40 pb-40">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="section-title mb-40">
              <h2 className='text-black ' >Featured <span>Games</span></h2>
            </div>
          </div>
        </div>
        <div className="row">
          {liveGames?.map((game) => (
            <Link to={`/details/${game._id}`} key={game._id} className="col-lg-4 col-md-6">
              <div className="upcoming-game-item mb-40">
                <div className="upcoming-game-head">
                  <div className="uc-game-head-title">
                    <h4>
                      <a href={game.link || '/#'} target="_blank" rel="noopener noreferrer">
                        {game.name}
                      </a>
                    </h4>
                  </div>
                </div>
                <p
                   style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                >
                  {game.longDescription || 'No description available.'}
                </p>
                <div className="upcoming-game-thumb">
                  <img
                    src={game.graphic || '/assets/img/images/default_game_thumb.jpg'}
                    alt={game.name}
                    style={{ height: '230px', objectFit: 'cover', width: '100%' }}
                  />
                  <div className="upcoming-game-cart">
                    <a
                      href={game.link || '/#'}
                      className="btn transparent-btn"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fas fa-shopping-basket" />Play Now
                    </a>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ReleaseGame;
